export const LIGHT_THEME = {
    colors: {
        PRIMARY: '#2C5530',
        SECONDARY: '#8B4513',
        ACCENT: '#DAA520',
        BACKGROUND: '#FFFFFF',
        SURFACE: '#F5F5F5',
        TEXT: '#333333',
        TEXT_SECONDARY: '#666666',
        ERROR: '#DC3545',
        SUCCESS: '#28A745',
        WARNING: '#FFC107',
        BORDER: '#E0E0E0',
        LINK: '#2C5530',
        BLACK: '#000000',
        WHITE: '#FFFFFF',
        // Golf-specific colors
        PAR: '#16A34A',
        OVER_PAR: '#000000',
        UNDER_PAR: '#DC2626',
        EVEN: '#FFFFFF',
        PAR_TEXT: '#FFFFFF',
        UNDER_PAR_TEXT: '#FFFFFF',
        OVER_PAR_TEXT: '#FFFFFF',
        // UI state colors
        DISABLED: '#CCCCCC',
        HOVER: '#E8F5E8',
        FOCUS: '#2C5530',
        // Input colors
        INPUT_BACKGROUND: '#FFFFFF',
        INPUT_TEXT: '#000000',
        INPUT_BORDER: '#DDDDDD',
        INPUT_BORDER_FOCUS: '#2C5530',
        // Button colors
        BUTTON_PRIMARY_BG: '#2C5530',
        BUTTON_PRIMARY_TEXT: '#FFFFFF',
        BUTTON_SECONDARY_BG: '#0066cc',
        BUTTON_SECONDARY_TEXT: '#FFFFFF',
        BUTTON_SUCCESS_BG: '#28A745',
        BUTTON_SUCCESS_TEXT: '#FFFFFF',
        BUTTON_ERROR_BG: '#DC3545',
        BUTTON_ERROR_TEXT: '#FFFFFF',
        // Google/Apple button colors
        GOOGLE_BG: '#FFFFFF',
        GOOGLE_TEXT: '#3C4043',
        GOOGLE_BORDER: '#DADCE0',
        APPLE_BG: '#000000',
        APPLE_TEXT: '#FFFFFF',
        // Highlighted items
        HIGHLIGHTED_ITEM: '#FFF9C4',
        // Navigation buttons
        NAVIGATION_BUTTON: '#0066cc',
        // Status colors
        STATUS_ACTIVE: '#FFF9C4',
        STATUS_COMPLETED: '#E8F5E8',
        STATUS_CANCELLED: '#FFEBEE',
    }
};

export const DARK_THEME = {
    colors: {
        PRIMARY: '#4A7558',
        SECONDARY: '#A65D35',
        ACCENT: '#DAA520',
        BACKGROUND: '#1A1A1A',
        SURFACE: '#2D2D2D',
        TEXT: '#F5F5F5',
        TEXT_SECONDARY: '#B0B0B0',
        ERROR: '#FF453A',
        SUCCESS: '#32D74B',
        WARNING: '#FFD60A',
        BORDER: '#404040',
        LINK: '#9BB5FF',
        BLACK: '#000000',
        WHITE: '#FFFFFF',
        // Golf-specific colors
        PAR: '#7ED957',
        OVER_PAR: '#23272F',
        UNDER_PAR: '#FF453A',
        EVEN: '#2D2D2D',
        PAR_TEXT: '#000000',
        UNDER_PAR_TEXT: '#FFFFFF',
        OVER_PAR_TEXT: '#FFFFFF',
        // UI state colors
        DISABLED: '#666666',
        HOVER: '#3A3A3A',
        FOCUS: '#4A7558',
        // Input colors
        INPUT_BACKGROUND: '#2D2D2D',
        INPUT_TEXT: '#F5F5F5',
        INPUT_BORDER: '#404040',
        INPUT_BORDER_FOCUS: '#4A7558',
        // Button colors
        BUTTON_PRIMARY_BG: '#4A7558',
        BUTTON_PRIMARY_TEXT: '#FFFFFF',
        BUTTON_SECONDARY_BG: '#0066cc',
        BUTTON_SECONDARY_TEXT: '#FFFFFF',
        BUTTON_SUCCESS_BG: '#32D74B',
        BUTTON_SUCCESS_TEXT: '#FFFFFF',
        BUTTON_ERROR_BG: '#FF453A',
        BUTTON_ERROR_TEXT: '#FFFFFF',
        // Google/Apple button colors
        GOOGLE_BG: '#2D2D2D',
        GOOGLE_TEXT: '#F5F5F5',
        GOOGLE_BORDER: '#404040',
        APPLE_BG: '#000000',
        APPLE_TEXT: '#FFFFFF',
        // Highlighted items
        HIGHLIGHTED_ITEM: '#3A3A3A',
        // Navigation buttons
        NAVIGATION_BUTTON: '#0066cc',
        // Status colors
        STATUS_ACTIVE: '#FFF9C4',
        STATUS_COMPLETED: '#E8F5E8',
        STATUS_CANCELLED: '#FFEBEE',
    }
}; 